import React, { useEffect, useState } from "react";
import { Container, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  GetWorkflowScheduleDetails,
  setGetWorkflowScheduleDetails,
} from "../services/ReduxTookit/Slice/WorkFlowRedux";
import { commonservices } from "../services/CommonServices";
import { CalculateMachineDurationSec } from "./Workflow/DataNewFlowPage";
import addIcon from "../assets/images/addSm.svg";
import minusIcon from "../assets/images/minusIcon.svg";
import { useLocation } from "react-router-dom";
import greenTick from "../assets/images/greenTick.svg";
import Loader, { LoaderType } from "./common-component/Loader";
import redTick from "../assets/images/redCross.svg";
import sminfo from "../assets/images/sminfo.svg";

function SchedularDetail() {
  const [expandedRow, setExpandedRow] = useState(null);

  const dispatch = useDispatch();
  const { state } = useLocation();

  const [Loading, setLoading] = useState(false);
  const FlowData = useSelector(
    (state) =>
      state?.workflowredux?.GetWorkflowScheduleDetailsData?.data?.data?.data
  );
  

  useEffect(() => {
    setLoading(true);
    if (state) {
      dispatch(GetWorkflowScheduleDetails({ id: state?.subscriberId }))?.then(
        (res) => {
          setLoading(false);
          setExpandedRow(
            res?.payload?.data?.data?.dataList1[0]?.workflowschedulelogid
          );
        }
      );
    }

    return () => {
      dispatch(setGetWorkflowScheduleDetails());
    };
  }, [state, dispatch]);

  const handleShowCollapse = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  return (
    <div className="schedular-page-main all-page-top schedular-detail-main">
      <Container>
        <div className="top-bot-section flex-column align-items-start gap-1">
          <h6>
            {" "}
            Schedule -{" "}
            <span style={{ color: "gray", fontSize: "16px" }}>
              {state?.flowName}
            </span>{" "}
            Scheduler
          </h6>
          <div className="schedule-subtext">
            <img
              src={sminfo}
              alt="sminfo"
              className="sminfo-in-table cursor-pointer"
              title="Schedule cron Information"
            />
            <p>{state?.cronData}</p>
          </div>
        </div>
      </Container>
      <div className="main-page-content">
        <Container>
          <div className="common-table-main">
            <div className="table-wrapper-main">
              <Table responsive>
                <thead>
                  <tr>
                    <th className="width100">Code</th>
                    <th className="width200 text-center">Date & Time</th>
                    <th className="text-center width125">Duration</th>
                    <th className="text-start width200">Component status</th>
                    <th className="width300">Machines</th>
                    <th className="width150">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {Loading ? (
                    <Loader type={LoaderType.TableRow} count={8} nooftd={6} />
                  ) : (
                    <>
                      {FlowData?.dataList1?.map((item, index) => {
                        const isExpanded =
                          expandedRow === item?.workflowschedulelogid;
                        return (
                          <React.Fragment key={index}>
                            <tr
                              className="dark-bg cursor-pointer"
                              onClick={() =>
                                handleShowCollapse(item?.workflowschedulelogid)
                              }
                            >
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  {item?.workflowschedulelogid !== 0 ? (
                                    <>
                                      <img
                                        src={isExpanded ? minusIcon : addIcon}
                                        alt="toggleIcon"
                                        className="cursor-pointer"
                                      />
                                      <span>
                                        {item?.workflowschedulelogid !== 0
                                          ? `#${item?.workflowschedulelogid}`
                                          : "-"}
                                      </span>
                                    </>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </td>
                              <td className="text-center">
                                {commonservices.getDateInFormatCustom(
                                  item?.starton,
                                  null,
                                  "MM/DD/yyyy"
                                )}
                              </td>
                              <td className="text-center">
                                {item?.workflowschedulelogid !== 0 ? (
                                  <CalculateMachineDurationSec
                                    Seconds={Math.ceil(item?.duration)}
                                  />
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className="text-center">
                                <div className="d-flex align-items-center gap-1 iconmainsedular">
                                  {item?.workflowschedulelogid !== 0 ? (
                                    item?.status === "end" ? (
                                      <>
                                        <img src={greenTick} alt="greenTick" />
                                        <span className="fw600 green-color-text">
                                          All Succeed
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        {" "}
                                        <img src={redTick} alt="redTick" />
                                        <span className="fw600 red-color-text">
                                          {
                                            FlowData?.dataList2?.filter(
                                              (item_1) =>
                                                item_1.workflowschedulelogid ===
                                                  item?.workflowschedulelogid &&
                                                item_1.status === "failed"
                                            )?.length
                                          }{" "}
                                          Failed
                                        </span>
                                      </>
                                    )
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </td>
                              <td></td>
                              <td>
                                <div className="status-active d-flex align-items-center gap-2">
                                  {item?.workflowschedulelogid === 0
                                    ? commonservices?.getlogPopupStatus(
                                        "Pending"
                                      )
                                    : commonservices?.getlogPopupStatus(
                                        item?.status === "end"
                                          ? "Completed"
                                          : item?.status === "start"
                                          ? "Running"
                                          : item?.status === "Partial Success"
                                          ? "Partial Success"
                                          : "Failed"
                                      )}
                                </div>
                              </td>
                            </tr>
                            {isExpanded &&
                              FlowData?.dataList2
                                ?.filter(
                                  (item_1) =>
                                    item_1.workflowschedulelogid ===
                                      item?.workflowschedulelogid &&
                                    item_1.modulename
                                      ?.split("|")[1]
                                      ?.toUpperCase() === " STARTER"
                                )
                                ?.map((item_2, index_2) => {
                                  return (
                                    <tr
                                      className="collepsed-table-row child-2"
                                      key={index_2}
                                    >
                                      <td></td>
                                      <td className="text-center">
                                        {item_2?.starton &&
                                          commonservices.convertTimeToLocal(
                                            item_2?.starton
                                          )}
                                      </td>
                                      <td className="text-center">
                                        <CalculateMachineDurationSec
                                          Seconds={Math.ceil(item_2?.duration)}
                                        />
                                      </td>
                                      <td></td>
                                      <td>{item_2?.modulename}</td>
                                      <td>
                                        <div className="status-active d-flex align-items-center gap-2">
                                          {commonservices?.getlogPopupStatus(
                                            item_2?.status === "end"
                                              ? "Completed"
                                              : item_2?.status === "start"
                                              ? "Running"
                                              : "Failed"
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            {isExpanded &&
                              FlowData?.dataList2
                                ?.filter(
                                  (item_1) =>
                                    item_1.workflowschedulelogid ===
                                      item?.workflowschedulelogid &&
                                    item_1.modulename
                                      ?.split("|")[1]
                                      ?.toUpperCase() !== " STARTER" &&
                                    item_1.modulename
                                      ?.split("|")[1]
                                      ?.toUpperCase() !== " EXIT"
                                )
                                ?.map((item_2, index_2) => {
                                  return (
                                    <tr
                                      className="collepsed-table-row child-2"
                                      key={index_2}
                                    >
                                      <td></td>
                                      <td className="text-center">
                                        {item_2?.starton &&
                                          commonservices.convertTimeToLocal(
                                            item_2?.starton
                                          )}
                                      </td>
                                      <td className="text-center">
                                        <CalculateMachineDurationSec
                                          Seconds={Math.ceil(item_2?.duration)}
                                        />
                                      </td>
                                      <td></td>
                                      <td>{item_2?.modulename}</td>
                                      <td>
                                        <div className="status-active d-flex align-items-center gap-2">
                                          {commonservices?.getlogPopupStatus(
                                            item_2?.status === "end"
                                              ? "Completed"
                                              : item_2?.status === "start"
                                              ? "Running"
                                              : "Failed"
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            {isExpanded &&
                              FlowData?.dataList2
                                ?.filter(
                                  (item_1) =>
                                    item_1.workflowschedulelogid ===
                                      item?.workflowschedulelogid &&
                                    item_1.modulename
                                      ?.split("|")[1]
                                      ?.toUpperCase() === " EXIT"
                                )
                                ?.map((item_2, index_2) => {
                                  return (
                                    <tr
                                      className="collepsed-table-row child-2"
                                      key={index_2}
                                    >
                                      <td></td>
                                      <td className="text-center">
                                        {item_2?.starton &&
                                          commonservices.convertTimeToLocal(
                                            item_2?.starton
                                          )}
                                      </td>
                                      <td className="text-center">
                                        <CalculateMachineDurationSec
                                          Seconds={Math.ceil(item_2?.duration)}
                                        />
                                      </td>
                                      <td></td>
                                      <td>{item_2?.modulename}</td>
                                      <td>
                                        <div className="status-active d-flex align-items-center gap-2">
                                          {commonservices?.getlogPopupStatus(
                                            item_2?.status === "end"
                                              ? "Completed"
                                              : item_2?.status === "start"
                                              ? "Running"
                                              : "Failed"
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                          </React.Fragment>
                        );
                      })}
                    </>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default SchedularDetail;
